<template>
    <div class="w-9/12 m-auto py-0 min-h-screen flex items-center justify-center">
        <div class="bg-white overflow-hidden sm:rounded-lg pb-2">
        <div class="text-center pt-0">
            <h1 class="text-9xl font-bold text-green-400">404</h1>
            <h1 class="text-4xl uppercase font-medium py-2">¡oops! Página no encontrada</h1>
            <p class="text-2xl px-12 uppercase font-medium">La página que solicitaste no existe</p>
        </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "page-not-found"
}
</script>

<style scoped>
    .text-9xl{
    font-size: 14rem;
    }
    @media(max-width: 645px){
    .text-9xl{
    font-size: 5.75rem;
    }
    .text-6xl{
    font-size: 1.75rem;
    }
    .text-2xl {
    font-size: 1rem;
    line-height: 1.2rem;
    }
    .py-8 {
    padding-top: 1rem;
    padding-bottom: 1rem;
    }
    .px-6 {
    padding-left: 1.2rem;
    padding-right: 1.2rem;
    }
    .mr-6{
    margin-right: 0.5rem;
    }
    .px-12 {
    padding-left: 1rem;
    padding-right: 1rem;
    }
    }
</style>

